var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { ref: "stars", staticClass: "stars" }, [
    _vm.showStars
      ? _c(
          "span",
          _vm._l(_vm.stars, function(star) {
            return _c("span", {
              key: "star-" + star.index,
              class: star.classes,
              style: star.styles
            })
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }